/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Component, OnInit } from "@angular/core";

@Component({
  selector: "taku-reports-form-list",
  templateUrl: "./reports-form-list.component.html",
  styleUrls: ["./reports-form-list.component.scss"],
})
export class ReportsFormListComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
